const Mapa1 = (params) => {
  const { redniBroj } = params;
  const url = `/images/mapa${redniBroj}.mp4`;
  return (
    <div className="clanak-page" id="clanak-page">
      <video className="clanak-img" autoPlay muted loop playsInline>
        <source src={url} type="video/mp4" />
      </video>
    </div>
  );
};

export default Mapa1;
